import React from 'react';
import { useBemCN } from '@gik/core/utils/bemBlock';

export interface IPopoverMenuItemProps extends React.HTMLAttributes<HTMLDivElement> {}

export const PopoverMenuItem: React.FC<IPopoverMenuItemProps> = ({ children, className, ...otherProps }) => {
  const bem = useBemCN('popover-menu-item');

  return (
    <div {...bem(null, null, className)} {...otherProps}>
      {children}
    </div>
  );
};
